import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Pillars } from "@/components/landing/Pillars";
import { CostOfNoTraining } from "@/components/landing/CostOfNoTraining";
import { HrBrand } from "@/components/landing/HrBrand";
import { Intelligence } from "@/components/landing/Intelligence";
import { Pricing } from "@/components/landing/Pricing";
import { Founder } from "@/components/landing/Founder";
import { CertWaitlist } from "@/components/landing/CertWaitlist";
import { DemoForm } from "@/components/landing/DemoForm";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="workspace-light bg-[#EDF4FB] text-slate-900 min-h-screen" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Pillars />
        <CostOfNoTraining />
        <HrBrand />
        <Intelligence />
        <Pricing />
        <Founder />
        <CertWaitlist />
        <DemoForm />
      </main>
      <Footer />
    </div>
  );
}
